import { render } from "./Ahpra.vue?vue&type=template&id=00975fd5"
import script from "./Ahpra.vue?vue&type=script&lang=js"
export * from "./Ahpra.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__